import _ from 'lodash'
import i18n from '@/lang'
import { fetchDeliveryCreatives } from '@pt/api/creative/delivery'
import { getGmakerProjectInfo } from '@pt/api/gmaker/project.js'
import shortid from 'shortid'
import { useChannelIdExchangeNonInteractiveChannelLabel } from '@/views/demand/utils/creation'
import { getPSProjectInfo } from '@ps/api/project.js'
const creative = {
  namespaced: true,

  state: {
    creativePreviewerDialog: {
      visible: false,
    },
    creativePreviewer: {
      // creatives: [{
      //             id: 1,
      //             preview_url: data.preview_url,
      //             creative_type: data.creative_type
      //           }], // 资源列表
      // groupId: number, // 组 id
      // currentCreativeId: number, // 当前资源 id
      // info: object, // {name: '', detail: [{value: '', label: ''}]}
      // switcherVisible: false
    },
  },

  mutations: {
    closeCreativePreviewerDialog(state) {
      state.creativePreviewerDialog.visible = false
      // 延迟 300 ms 清空数据
      window.setTimeout(() => {
        state.creativePreviewer = {}
      }, 300)
    },
  },

  actions: {
    /**
     * 预览需求的非交互素材资源
     * @param {any} param0
     * @param {{group_id: number, product_name: string, source_id: number, preview_url?: string, creative_type?: string}} data
     */
    async previewMaterialDemandCreative({ state }, data) {
      if (!data.source_id || !data.product_name) {
        throw new Error('source_id/product_name is required')
      }

      const sourceId = data.source_id // 用于展示
      const info = {
        // 产品名字
        name: data.product_name,
        detail: [
          {
            value: sourceId,
            label: i18n.t('playTurbo.common.previewDialog.playable') + '：',
          },
        ],
      }

      // 有 preview_url 代表是预览单个资源
      if (data.preview_url) {
        if (!data.creative_type) {
          throw new Error('creative_type is required')
        }

        state.creativePreviewerDialog.visible = true
        state.creativePreviewer = {
          creatives: [
            {
              id: 1,
              preview_url: data.preview_url,
              creative_type: data.creative_type,
            },
          ],
          currentCreativeId: 1,
          info,
          switcherVisible: false,
        }
      } else if (data.group_id) {
        const groupId = data.group_id // 用于推送和获取组内资源
        const res = await fetchDeliveryCreatives({ group_id: groupId })
        const list = _.get(res, 'data.data.list') || []

        state.creativePreviewerDialog.visible = true
        if (list.length > 0) {
          state.creativePreviewer = {
            creatives: list.map((item) => {
              let size = ''
              if (item.creative_ext) {
                try {
                  const ext = JSON.parse(item.creative_ext)
                  size = `${ext.width || '*'}x${ext.height || '*'}`
                } catch (e) {
                  size = ''
                }
              }
              return {
                ...item,
                // 拼接数据用于展示
                label:
                  useChannelIdExchangeNonInteractiveChannelLabel(
                    item.channel_id,
                  ) +
                  '_' +
                  size,
              }
            }),
            groupId,
            currentCreativeId: list[0].id,
            info,
            switcherVisible: true,
          }
        }
      }
    },
    async previewPlayable({ state, rootState }, data) {
      if (!data.source_id || !data.product_name) {
        throw new Error('source_id/product_name is required')
      }

      const sourceId = data.source_id // 用于展示
      // material_type 素材类型
      const materialCategory = (
        (rootState.config.gmaker.material_categories || []).find(
          (item) => item.id === data.material_category,
        ) || {}
      ).name

      const info = {
        // 产品名字
        name: data.product_name,
        tag: materialCategory,
        detail: [
          {
            value: sourceId,
            label: i18n.t('playTurbo.common.previewDialog.playable') + '：',
          },
        ],
      }

      if (data.detail) {
        info.detail = data.detail
      }

      // 玩法模版隐藏「素材类型」和「制作时长」，改为显示「一、二级标签」和「难度等级」
      if (data.pageType === 'index' || data.pageType === 'star') {
        info.detail = []
        info.tag = ''
        info.playMethods = []
        info.difficultyLevel = []
        info.dimension_type = data.dimension_type
        info.model_count = data.model_count
        info.action_count = data.action_count

        // 玩法模版增加一、二级标签展示
        if (data.play_methods && rootState.config.gmaker.play_methods.length) {
          const templateIdsTemp = data.play_methods.split(',')

          const filterbrandLabel = (data, value) => {
            const labelAll = []
            for (const item of value) {
              for (const v of data) {
                if (v.child) {
                  const childName = (
                    v.child.find((s) => Number(item) === s.id) || {}
                  ).name

                  if (childName) {
                    labelAll.push(`${v.name}-${childName}`)
                  }
                } else {
                  if (Number(item) === v.id) {
                    labelAll.push(v.name)
                  }
                }
              }
            }
            return labelAll
          }

          info.playMethods = filterbrandLabel(
            rootState.config.gmaker.play_methods,
            templateIdsTemp,
          )
        }

        // 玩法模版增加「难度等级」标签展示
        if (data.difficulty_level) {
          const difficultyLevel = (
            (rootState.config.gmaker.difficulty_levels || []).find(
              (item) => item.id === data.difficulty_level,
            ) || {}
          ).name
          info.difficultyLevel.push({
            label: i18n.t('playTurbo.commonTemplate.previewDialog.difficulty'),
            value: difficultyLevel,
          })
        }
      }

      // 有 preview_url 代表是预览单个资源
      if (data.preview_url && typeof data.preview_url === 'string') {
        if (data.skin_id) {
          // 如果还有皮肤 id 则需要从接口获取最新的预览链接
          state.creativePreviewer = {
            creatives: [
              {
                id: 1,
                preview_url: data.preview_url,
                creative_type: 3,
              },
            ],
            source_id: data.source_id,
            skin_id: data.skin_id,
            currentCreativeId: 1,
            info,
            switcherVisible: false,
          }
        } else {
          state.creativePreviewer = {
            creatives: [
              {
                id: 1,
                preview_url: data.preview_url,
                creative_type: 3,
              },
            ],
            custom_id: data.custom_id,
            currentCreativeId: 1,
            info,
            switcherVisible: false,
          }
        }
        state.creativePreviewerDialog.visible = true
      } else if (data.preview_url && typeof data.preview_url === 'object') {
        //
        info.detail = []
        const list = data.preview_url.map((url, index) => {
          return {
            id: index + 1,
            name: 'playable' + (index + 1),
            preview_url: url,
            creative_type: 3,
          }
        })
        state.creativePreviewer = {
          creatives: list,
          custom_id: data.custom_id,
          currentCreativeId: 1,
          info,
          switcherVisible: list.length > 1,
        }
        state.creativePreviewerDialog.visible = true
      } else {
        let res
        if (
          data.project_type === 'playsmart' ||
          data.pageType === 'myTemplate' ||
          data.project_type === 'iv'
        ) {
          // 此处获取项目信息（包含预览页面在线路径）
          res = await getPSProjectInfo({
            id: data.custom_id,
          })
        } else {
          res = await getGmakerProjectInfo({
            project_id: data.custom_id,
          })
        }
        const list = _.get(res, 'data.data.groups_config')
          ? JSON.parse(_.get(res, 'data.data.groups_config'))
          : []

        if (list.length > 0) {
          const temp = list.map((item) => {
            // 列表内容处理
            return {
              id: shortid(),
              ...item,
              creative_type: 3,
            }
          })
          state.creativePreviewer = {
            creatives: temp,
            custom_id: data.custom_id,
            currentCreativeId: temp[0].id,
            info,
            switcherVisible: list.length > 1,
          }
        } else {
          if (data.project_type === 'playsmart' || data.project_type === 'iv') {
            info.detail = []
          }
          state.creativePreviewer = {
            creatives: [
              {
                id: 1,
                name: '默认组合',
                preview_url: data.template_url,
                creative_type: 3,
              },
            ],
            custom_id: data.custom_id,
            currentCreativeId: 1,
            info,
            switcherVisible: false,
          }
        }
        state.creativePreviewerDialog.visible = true
      }
    },
  },
}

export default creative
